export default {
	init() {
		// JavaScript to be fired on the home page
		$('.slider-home .slider-inner').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			infinite: true,
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000,
			appendArrows: '.slider-home .slider-control',
		});
		$('.slider-service .slider-inner').slick({
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: true,
			swipeToSlide: true,
			appendArrows: '.slider-service .slider-control',
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerMode: false,
						variableWidth: false,
						adaptiveHeight: true,
					},
				},
			],
		});
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js